import apiClient from '../apiClient';
import { PUT_COUNTRY_URL } from '../apiUrl';

const putCountryApi = (id, data) => {
  return apiClient.put(PUT_COUNTRY_URL(id), data);
};

export default putCountryApi;
